{
  "version": 1,
  "asset_id": "dd8722d9-8e23-49e4-907b-332700434588",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/dd8722d9-8e23-49e4-907b-332700434588/applied-platinum.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/dd8722d9-8e23-49e4-907b-332700434588/applied-platinum.jpeg",
  "original_filename": "applied-platinum.jpeg",
  "size": 905203,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:26Z"
}
